export default function _qualification() {}

_qualification();
